"use strict";
var $dyn;
(function ($dyn) {
    $(document).on("mousemove", function (e) {
        $dyn.shell.previewManager._displayedPreviewMouseMoveEvent = e;
    });
    var shell;
    (function (shell) {
        var previewManager;
        (function (previewManager) {
            previewManager._displayedPreview = null;
            previewManager._displayedPreviewMouseMoveEvent = null;
            previewManager._previewCloseTimer = -1;
            previewManager._displayedPreviewControlClass = null;
            previewManager._displayedPreviewControlElement = null;
            previewManager._closeInterval = -1;
            previewManager._hostControlOffset = null;
            previewManager._previewRequestPending = false;
            function hasOpenPreview() {
                if ($dyn.shell.previewManager._displayedPreview) {
                    return true;
                }
                else {
                    return false;
                }
            }
            previewManager.hasOpenPreview = hasOpenPreview;
            function setActive() {
                if ($dyn.shell.previewManager._displayedPreview) {
                    $dyn.context($dyn.shell.previewManager._displayedPreview).IsActive(true);
                }
            }
            previewManager.setActive = setActive;
            function enhancedPreviewShortcutHandler(control, evt) {
                if (control.CanHavePreview && control.RequestEnhancedPreview) {
                    if ($dyn.shell.previewManager.hasOpenPreview()) {
                        $dyn.shell.previewManager.removePreview();
                        var tempElement_1 = control.element;
                        window.setTimeout(function () {
                            $dyn.preview.tryOpenPreview(tempElement_1, evt);
                        }, 250);
                    }
                    else {
                        // is it blocked from a preview? show tooltip instead
                        if ($dyn.value(control.CanHavePreview)) {
                            $dyn.preview.tryOpenPreview(control.element, evt);
                        }
                        else {
                            $dyn.superTooltip.tryOpenSuperTooltip(control.element);
                        }
                    }
                    return true;
                }
                return false;
            }
            previewManager.enhancedPreviewShortcutHandler = enhancedPreviewShortcutHandler;
            function displayPreview(controlClass, element, isShortcut) {
                // only show one popup at a time
                if (!$dyn.shell.previewManager.hasOpenPreview()) {
                    $(document.body).on("resetShellOnNavigation.dynPreviewManager", function () {
                        $dyn.shell.previewManager.removePreview();
                    });
                    // create the preview
                    // note the controlClass.element and the element may not be the same when the preview is hosted in a grid
                    var preview_1 = $dyn.shell.previewManager.createPreview(controlClass, element, isShortcut);
                    if (preview_1) {
                        // store the control instance, preview and capture the mouse location
                        $dyn.shell.previewManager._displayedPreviewControlClass = controlClass;
                        $dyn.shell.previewManager._displayedPreviewControlElement = element;
                        $dyn.shell.previewManager._displayedPreview = preview_1;
                        // position the beak
                        $(preview_1).position({
                            at: "center top",
                            collision: "fit flip",
                            my: "center bottom",
                            of: $dyn.shell.previewManager._displayedPreviewControlElement,
                            offset: "-20 -10",
                        });
                        // show the beak
                        preview_1.style.display = "";
                    }
                }
            }
            previewManager.displayPreview = displayPreview;
            /**
             * Configure the form for the preview
             * @param controlClass The control hosting the preview form
             * @param form The preview form
             * @param isShortcut True if this preview was opened with a shortcut
             */
            function configurePreviewForm(controlClass, form, isShortcut) {
                if (form) {
                    // if its a shortcut allow it to take focus
                    if (isShortcut === true) {
                        form.TakeFocus = true;
                    }
                    else {
                        form.TakeFocus = false;
                    }
                    form.IsPreviewForm = true;
                    form.takeFocusOnOpen = false;
                    form.IgnoreBlockingDiv = function (commandName) {
                        return commandName === "RequestClose";
                    };
                    // get the focused control on the host controls form so focus can be returned to it
                    if (controlClass.Root) {
                        var focusTarget_1 = $(controlClass.Root.GetFocusedControl());
                        form.FindFocusTarget = function () {
                            return focusTarget_1;
                        };
                        // hook the tab key so we can dismiss the preview when the users changes controls
                        focusTarget_1.on("keydown.showPreview", function (evt) {
                            if (evt.which === $dyn.ui.KeyCodes.tab) {
                                // Let focus change finish processing before we close the preview. This allows the shell stack to correctly
                                // manage focus while closing the preview.
                                window.setTimeout(function () {
                                    $dyn.shell.previewManager.closePreview($dyn.shell.previewManager._displayedPreviewControlClass, true);
                                });
                            }
                        });
                    }
                }
            }
            previewManager.configurePreviewForm = configurePreviewForm;
            function createPreview(controlClass, element, isShortcut) {
                // create the form, attach and bind
                var targetElement = $dyn.shell.createForm({ role: "Preview" });
                // get the client form id to pass to the server
                var previewPopupId = targetElement.getAttribute("data-dyn-formid");
                // store the host control offset
                if (element) {
                    $dyn.shell.previewManager._hostControlOffset = $(element).offset();
                }
                else {
                    $dyn.shell.previewManager._hostControlOffset = $(controlClass.element).offset();
                }
                var form = $dyn.context(targetElement);
                $dyn.shell.previewManager.configurePreviewForm(controlClass, form, isShortcut);
                var rowIndex = controlClass.serverIndex >= 0 ? controlClass.serverIndex : -1;
                var convertTrackingId = false;
                if (controlClass.Root && controlClass.Root.UseReactGrid() && controlClass.convertMasterTrackingId) {
                    convertTrackingId = true;
                }
                // request the preview and pass the client id so the form is linked
                var previewRequestCommand = $dyn.value(controlClass.RequestEnhancedPreview);
                if (previewRequestCommand) {
                    previewRequestCommand([previewPopupId, rowIndex, convertTrackingId], undefined, function () {
                        window.setTimeout(function () {
                            $dyn.shell.previewManager._previewRequestPending = false;
                            // tslint:disable-next-line: no-shadowed-variable
                            var canOpenPreview = $dyn.shell.canOpenPreview(controlClass.Root);
                            if (canOpenPreview) {
                                // this is delayed so the form has height before its positioned
                                $dyn.shell.previewManager.positionPreview();
                                if (form && form.element) {
                                    if (isShortcut) {
                                        // set focus to the preview olny when its launched from a shortcut key
                                        var firstFocusableControl = $dyn.util.findFirstFocusableControl($(form.element));
                                        var hasInput_1 = false;
                                        if (firstFocusableControl) {
                                            // if there is a focusable control inside preview, set focus to the first
                                            firstFocusableControl.focus();
                                            hasInput_1 = true;
                                        }
                                        else {
                                            // else set focus to the whole preview
                                            form.element.focus();
                                        }
                                        // check child controls for to make sure
                                        var closePreviewOpenedWithShortcut_1 = function (event) {
                                            $dyn.shell.previewManager.removePreview();
                                            if (controlClass && controlClass.Root && controlClass.Root.takeNavigationFocus) {
                                                controlClass.Root.takeNavigationFocus();
                                            }
                                            if (event.which === $dyn.ui.KeyCodes.esc) {
                                                $dyn.log.stopPropagation && $dyn.log.stopPropagation("Preview close shortcut.");
                                                event.stopPropagation();
                                            }
                                            else {
                                                $(document.body).off("mousedown.Preview");
                                            }
                                        };
                                        var previewMouseDown = function (event) {
                                            var isClickInPreview = $dyn.util.flyout.isCoordinateInside(event.clientX, event.clientY, $(form.element));
                                            if (!isClickInPreview) {
                                                closePreviewOpenedWithShortcut_1(event);
                                            }
                                        };
                                        $(document.body).on("mousedown.Preview", previewMouseDown);
                                        form.element.onkeydown = function (event) {
                                            if (event.which === $dyn.ui.KeyCodes.esc) {
                                                closePreviewOpenedWithShortcut_1(event);
                                            }
                                            if (!hasInput_1 && (event.which === $dyn.ui.KeyCodes.tab)) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                            }
                                        };
                                    }
                                    else {
                                        // tslint:disable-next-line: no-shadowed-variable
                                        var closePreview_1 = function (event) {
                                            $dyn.shell.previewManager.removePreview();
                                            if (controlClass && controlClass.Root && controlClass.Root.takeNavigationFocus) {
                                                controlClass.Root.takeNavigationFocus();
                                            }
                                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Preview close shortcut.");
                                            event.stopPropagation();
                                            $(document.body).off("keydown.Preview");
                                        };
                                        // If not opened by shortcut, then add a keydown handler to the document.body to handle esc to close
                                        $(document.body).on("keydown.Preview", function (evt) {
                                            if (evt.which === $dyn.ui.KeyCodes.esc) {
                                                closePreview_1(evt);
                                            }
                                        });
                                    }
                                }
                            }
                            else {
                                $dyn.shell.previewManager.removePreview();
                            }
                        }, 0);
                    });
                    $dyn.shell.previewManager._previewRequestPending = true;
                }
                // hide the inner content and remove the border (sysPopup)
                $dyn.shell.previewManager.updateBorderDisplayProperty(targetElement, "none");
                targetElement.classList.remove("sysPopup");
                // bind the mouse events to track hovered on the preview
                $(targetElement).on("mouseleave", function () {
                    controlClass.isPreviewHovered(false);
                    $dyn.shell.previewManager.closePreview(controlClass);
                });
                $(targetElement).on("mouseenter", function () {
                    controlClass.isPreviewHovered(true);
                });
                return targetElement;
            }
            previewManager.createPreview = createPreview;
            function removePreview() {
                // force the preview to close
                if ($dyn.shell.previewManager._displayedPreviewControlClass) {
                    // hide the preview until its closed
                    if ($dyn.shell.previewManager._displayedPreview) {
                        $dyn.shell.previewManager._displayedPreview.style.display = "none";
                    }
                    $dyn.shell.previewManager._displayedPreviewControlClass.isPreviewControlHovered(false);
                    $dyn.shell.previewManager._displayedPreviewControlClass.isPreviewHovered(false);
                    $dyn.shell.previewManager.closePreview($dyn.shell.previewManager._displayedPreviewControlClass);
                }
            }
            previewManager.removePreview = removePreview;
            function closePreview(controlClass, forceClose) {
                if (forceClose) {
                    $dyn.log.test && $dyn.log.test.error && $dyn.log.test.error("Preview -force close");
                    var previewForm = $dyn.context($dyn.shell.previewManager._displayedPreview);
                    if (previewForm) {
                        $dyn.shell.previewManager.cleanupPreviewForm();
                        previewForm.IsActive(false);
                    }
                    // hide the preview until its closed
                    if ($dyn.shell.previewManager._displayedPreview) {
                        $dyn.shell.previewManager._displayedPreview.style.display = "none";
                    }
                }
                else if (controlClass &&
                    $dyn.shell.previewManager._displayedPreviewControlClass === controlClass &&
                    !controlClass.isPreviewControlHovered() &&
                    !controlClass.isPreviewHovered()) {
                    // if the control requesting the close opened the preview and it and the preview are not hovered or we have a empty preview
                    if ($dyn.shell.previewManager.hasOpenPreview() && $dyn.shell.previewManager._previewCloseTimer === -1) {
                        // if there is an open preview and a request to close it is not added yet
                        // delay the close for the mouse transition between source control and the preview
                        $dyn.shell.previewManager._previewCloseTimer = window.setTimeout(function () {
                            // reset the timer
                            $dyn.shell.previewManager._previewCloseTimer = -1;
                            // if the control and preview are not hovered still and the preview is open
                            if ((!controlClass.isPreviewControlHovered() && !controlClass.isPreviewHovered() && $dyn.shell.previewManager.hasOpenPreview())) {
                                $dyn.shell.previewManager.clearPreviewCloseInterval();
                                var previewForm = $dyn.context($dyn.shell.previewManager._displayedPreview);
                                if (previewForm) {
                                    $dyn.shell.previewManager.cleanupPreviewForm();
                                }
                                // hide the preview until its closed
                                if ($dyn.shell.previewManager._displayedPreview) {
                                    $dyn.shell.previewManager._displayedPreview.style.display = "none";
                                }
                            }
                        }, 50);
                    }
                }
            }
            previewManager.closePreview = closePreview;
            function cleanupPreviewForm() {
                var previewHasFocus = false;
                var previewFormElement = $dyn.shell.previewManager._displayedPreview;
                if ($(document.activeElement).closest(previewFormElement).length > 0) {
                    // Note: the focus needs to be checked before close as in close the focus will be already on the body.
                    previewHasFocus = true;
                }
                var previewForm = $dyn.context(previewFormElement);
                if (previewForm) {
                    // if there was a request and they are closing it before the server returned the form wait
                    if ($dyn.shell.previewManager._previewRequestPending) {
                        window.setTimeout($dyn.shell.previewManager.cleanupPreviewForm, 20);
                    }
                    else {
                        // override the default close (navigate.back) to remove the preview
                        previewForm._close = function () {
                            // the preview does not take focus
                            if (previewHasFocus) {
                                // but if the case when the user clicked  it (to copy data for example)
                                // we need to return focus when the preview closes
                                var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                                if (activeForm_1) {
                                    $dyn.log.focus && $dyn.log.focus("Focus: cleanupPreviewForm Form(Form.Id: %s) setting focus back to the active form", previewForm.Id);
                                    activeForm_1.takeNavigationFocus();
                                }
                            }
                            $dyn.shell.previewManager.cleanupClientPreview();
                        };
                        // Call the form's Close for proper cleanup
                        $dyn.getFunction($dyn.context($dyn.shell.previewManager._displayedPreview).Close)();
                    }
                }
            }
            previewManager.cleanupPreviewForm = cleanupPreviewForm;
            function cleanupClientPreview() {
                $($dyn.shell.previewManager._displayedPreview).remove();
                $($dyn.shell.previewManager._displayedPreviewControlElement).off(".showPreview");
                var previewContext = $dyn.context($dyn.shell.previewManager._displayedPreview);
                if (previewContext) {
                    var focusTarget = previewContext.FindFocusTarget ? previewContext.FindFocusTarget() : undefined;
                    if (focusTarget) {
                        focusTarget.off(".showPreview");
                    }
                    if (previewContext.Id && $dyn.serverForm) {
                        $dyn.serverForm.ModelManager.removeFormModelsAndCollections(previewContext.Id);
                    }
                }
                if ($dyn.shell.previewManager._displayedPreviewControlClass) {
                    $dyn.shell.previewManager._displayedPreviewControlClass.PreviewRequested = false;
                    $dyn.shell.previewManager._displayedPreviewControlClass.isPreviewControlHovered(false);
                    $dyn.shell.previewManager._displayedPreviewControlClass.isPreviewHovered(false);
                }
                $dyn.shell.previewManager._displayedPreview = null;
                $dyn.shell.previewManager._displayedPreviewControlClass = null;
                $dyn.shell.previewManager._displayedPreviewControlElement = null;
                // remove the navigation close handler
                $(document.body).off("resetShellOnNavigation.dynPreviewManager");
            }
            previewManager.cleanupClientPreview = cleanupClientPreview;
            function positionPreview() {
                // make sure the control is still Visible
                var controlClass = $dyn.shell.previewManager._displayedPreviewControlClass;
                var isVisible = ($dyn.value(controlClass.Visible) && $($dyn.shell.previewManager._displayedPreviewControlElement).is(":visible"));
                var element = $dyn.shell.previewManager._displayedPreviewControlElement;
                var $element = $(element);
                // did the preview have content
                var rootLayout = $($dyn.shell.previewManager._displayedPreview).find(".rootLayout")[0];
                var rootChildrenCount = 0;
                if (rootLayout) {
                    rootChildrenCount = $(rootLayout).children().length;
                }
                if (!isVisible || rootChildrenCount === 0) {
                    if (controlClass) {
                        if (rootChildrenCount === 0) {
                            $dyn.setValue(controlClass, "CanHavePreview", false);
                        }
                        if (element) {
                            $dyn.preview.restoreToolTip(element);
                        }
                    }
                    // add telemetry if we called to display the preview but it was not shown
                    $dyn.telemetry.addControlActionEvent(controlClass, null, $dyn.telemetry.ActionEvents.previewDisplayed, { userDefined1: 0 });
                    $dyn.shell.previewManager.cleanupClientPreview();
                    // we need to also special case call the mouse enter function to see if continuation is needed
                    var event_1 = { currentTarget: element, target: element };
                    $dyn.onMouseEvent.callMouseEnterFunction(event_1);
                    return;
                }
                // add telemetry if the preview was displayed
                $dyn.telemetry.addControlActionEvent(controlClass, null, $dyn.telemetry.ActionEvents.previewDisplayed, { userDefined1: 1 });
                // Set the preview form element IsActive so that layout runs on the preview form element
                $dyn.shell.previewManager.setActive();
                var form = $dyn.context($dyn.shell.previewManager._displayedPreview);
                var positionForm = function () {
                    if ($dyn.shell.previewManager._displayedPreview) {
                        // show the border and the inner content
                        $dyn.shell.previewManager._displayedPreview.classList.add("sysPopup");
                        $dyn.shell.previewManager.updateBorderDisplayProperty($dyn.shell.previewManager._displayedPreview, "");
                        // figure out if the preview is to big to fit
                        var previewHeight = $($dyn.shell.previewManager._displayedPreview).outerHeight();
                        var elementTop = $element.offset().top;
                        var elementHeight = $element.height();
                        var windowHeight = $(window).height();
                        // What is the space under and over the target element? Get the max space available
                        var spaceUnder = windowHeight - (elementTop + elementHeight + 25);
                        var spaceOver = elementTop - 25;
                        var maxSpace = (spaceOver > spaceUnder) ? spaceOver : spaceUnder;
                        // if the preview is taller that the available space
                        // jquery position does not handle this case well so set a max height
                        if (maxSpace < previewHeight) {
                            $($dyn.shell.previewManager._displayedPreview).find(".preview-inner").css({ "max-height": (maxSpace) + "px" });
                        }
                        var ofTarget = element;
                        if (!controlClass.isInGrid() && controlClass.$inputElement) {
                            ofTarget = controlClass.$inputElement[0];
                        }
                        // position the preview
                        $($dyn.shell.previewManager._displayedPreview).position({
                            at: "center top",
                            collision: "fit flip",
                            my: "left-22 bottom",
                            of: ofTarget,
                            using: function (position) {
                                var top = $(element).offset().top;
                                var left = $(element).offset().left;
                                var beak = $($dyn.shell.previewManager._displayedPreview).find(".preview-Beak");
                                // check for the case that position shifted the preview
                                if (left > position.left + 20) {
                                    // we need to shift the beak
                                    beak.css({ "position": "absolute", "left": (left - position.left - 22) + "px" });
                                }
                                // check for the case that position flipped it on the y
                                if (top < position.top) {
                                    beak.removeClass("preview-Beak-Down");
                                    beak.addClass("preview-Beak-Up");
                                    beak.css({ "top": "0" });
                                }
                                // position the preview
                                $($dyn.shell.previewManager._displayedPreview).css({ top: position.top });
                                $($dyn.shell.previewManager._displayedPreview).css({ left: position.left });
                            }
                        });
                        $($dyn.shell.previewManager._displayedPreviewControlElement).on("mousedown.showPreview DOMMouseScroll.showPreview mousewheel.showPreview", function () {
                            $dyn.shell.previewManager.closePreview($dyn.shell.previewManager._displayedPreviewControlClass, true);
                        });
                        $dyn.shell.previewManager._closeInterval = window.setInterval($dyn.shell.previewManager.checkPreviewClose, 500);
                    }
                };
                if (form && $dyn.value(form.waitForAsyncRender)) {
                    $dyn.observe(form.waitForAsyncRender, function (value) {
                        if (!value) {
                            $dyn.async(function () {
                                positionForm();
                            }, undefined, "Position form after grid is done rendering");
                            return false;
                        }
                    });
                }
                else {
                    positionForm();
                }
            }
            previewManager.positionPreview = positionPreview;
            function updateBorderDisplayProperty(element, newValue) {
                var innerElement = element.querySelector(".preview-inner");
                if (innerElement) {
                    innerElement.style.display = newValue;
                }
                var beakElement = element.querySelector(".preview-Beak");
                if (beakElement) {
                    beakElement.style.display = newValue;
                }
            }
            previewManager.updateBorderDisplayProperty = updateBorderDisplayProperty;
            function checkPreviewClose() {
                var previewControl = $dyn.shell.previewManager._displayedPreviewControlClass;
                // check to see if the host control has moved
                if ($dyn.shell.previewManager.hasOpenPreview() && previewControl) {
                    var shouldClose = false;
                    var hostControlOffset = $dyn.shell.previewManager._hostControlOffset;
                    if (hostControlOffset) {
                        var newOffset = $($dyn.shell.previewManager._displayedPreviewControlElement).offset();
                        if (newOffset === undefined || (hostControlOffset.left !== newOffset.left || hostControlOffset.top !== newOffset.top)) {
                            shouldClose = true;
                        }
                    }
                    // when the grid filters we can orphan previews as the control / row get removed or partially cleared
                    if ($dyn.value(previewControl.Value) === undefined || !$.contains(document.body, previewControl.element)) {
                        shouldClose = true;
                    }
                    if (shouldClose) {
                        $dyn.shell.previewManager.clearPreviewCloseInterval();
                        $dyn.shell.previewManager.closePreview(previewControl, true);
                    }
                }
                else {
                    $dyn.shell.previewManager.clearPreviewCloseInterval();
                }
            }
            previewManager.checkPreviewClose = checkPreviewClose;
            function clearPreviewCloseInterval() {
                // stop polling
                if ($dyn.shell.previewManager._closeInterval !== -1) {
                    window.clearInterval($dyn.shell.previewManager._closeInterval);
                    $dyn.shell.previewManager._closeInterval = -1;
                }
            }
            previewManager.clearPreviewCloseInterval = clearPreviewCloseInterval;
            function canOpenPreview(controlClass, previewElement, isShortcut) {
                if ($dyn.flags.disablePreview) {
                    return false;
                }
                var previewCanOpen = false;
                var isNonActiveGridControl = false;
                // make sure the control is still Visible
                var isVisible = ($dyn.value(controlClass.Visible) && $(previewElement).is(":visible"));
                var isValid = true;
                // if this is the active control check the valid state
                // if this is not the active row (grids) the control cannot be valid and the
                // dynContext for that row is based on the active row so its incorrect for this instance
                if (previewElement.dynContext && controlClass.controlIsValid) {
                    isValid = controlClass.controlIsValid();
                }
                else {
                    isNonActiveGridControl = true;
                }
                // only request a preview if the control is hovered and there is not a preview already open
                if (isVisible &&
                    isValid &&
                    $dyn.value(controlClass.isPreviewControlHovered) &&
                    !$dyn.shell.previewManager._previewRequestPending &&
                    (!$dyn.shell.previewManager.hasOpenPreview() ||
                        $dyn.shell.previewManager._previewCloseTimer !== -1)) {
                    // does the control have a value and is it set or is it a list or is it an image
                    if (($dyn.value(controlClass.Value) &&
                        $dyn.value(controlClass.Value) !== "") ||
                        controlClass.SelectedItem ||
                        controlClass.TypeName === "Image") {
                        // if the request is for a control with a open flyout  don't allow a preview
                        if (!(controlClass.ShowFlyout && $dyn.value(controlClass.ShowFlyout))) {
                            // we also do not want a preview opened for the control with focus
                            if (!$dyn.shell.isActiveControl(controlClass) || isShortcut || isNonActiveGridControl) {
                                previewCanOpen = true;
                            }
                        }
                    }
                }
                if (!isValid && !previewCanOpen) {
                    $dyn.preview.restoreToolTip(previewElement);
                }
                return previewCanOpen;
            }
            previewManager.canOpenPreview = canOpenPreview;
        })(previewManager = shell.previewManager || (shell.previewManager = {}));
    })(shell = $dyn.shell || ($dyn.shell = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PreviewManager.js.map
